<template>
	<b-container>
		<b-form @submit.prevent="createClock">
			<b-row class="mt-3">
				<b-col>
					<h1>Create new clock</h1>
				</b-col>

				<b-col>
					<b-link :to="{ name: 'clocks' }" title="Cancel" class="float-right ml-3 btn btn-link">
						<b-icon font-scale="1.5" icon="trash" variant="danger"></b-icon>
					</b-link>

					<b-button type="submit" variant="link" title="Save new clock" class="float-right ml-3">
						<b-icon font-scale="1.5" icon="check-square" variant="success"></b-icon>
					</b-button>
				</b-col>
			</b-row>

			<b-row class="mt-3">
				<b-col cols="6">
					<b-form-group breakpoint="md" horizontal>
						<b-form-input id="name" placeholder="Clock Name" v-model="clock.Name" maxlength="60" required />
					</b-form-group>
				</b-col>
			</b-row>
		</b-form>

		<b-modal ref="alertModal" :title="alertModalTitle" :ok-only="true" @ok="onAlertModalOkClick">
			<p class="my-4">{{ alertModalContent }}</p>
		</b-modal>
	</b-container>
</template>

<script>
import ClockService from '@/api-services/clock.service';

export default {
	name: 'ClockCreate',

	data() {
		return {
			clock: {
				Address: {},
				Customer: {},
				ClockType: {},
				Equipment: [],
				Escapements: [],
				Dials: [],
				Contacts: [],
				Assets: [],
				HourStrike: false,
				Carillon: false
			},

			alertModalTitle: '',
			alertModalContent: '',
			isSuccess: false
		};
	},

	methods: {
		createClock() {
			ClockService.create(this.clock)
				.then((res) => {
					this.clock.Id = res.data.Id;
					this.saveAndContinue();
				})
				.catch((error) => {
					this.isSuccess = false;
					this.alertModalTitle = 'Error';
					this.alertModalContent = error.response.data;
					this.$refs.alertModal.show();
				});
		},

		onAlertModalOkClick() {
			if (this.isSuccess) {
				this.$router.push({ name: 'clocks' });
			}
		},

		saveAndContinue() {
			this.$router.push({
				name: 'clockupdate',
				params: { id: this.clock.Id },
				query: { creating: true }
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/clock/clock-create.vue